export default __webpack_public_path__ + "static/media/metamask-icon.6882add5.png";